import React from 'react';

export const DEBT_TYPE_MAP = {
  creditCard: {
    icon: 'credit-card',
    title: 'Enter your credit card debt details',
    buttonText: 'Add credit card debt',
    label: 'Credit card debt',
    value: 'creditCard',
    interestRateStat: 'The national average is 19.3%. If yours is different, edit the field below.',
    interestRateSource: (
      <span>
        The national average credit card rate is based on a credit score of 670-739. Rate sourced from{' '}
        <a href="https://wallethub.com/">wallethub.com</a>, 2020.
      </span>
    ),
    defaultInterestRate: 19.3,
    listTitle: 'Credit Card Debt',
    xAxisLabel: 'Credit Card',
    colors: {
      balance: '#746BFF',
      interest: '#5342F7',
    },
  },
  autoLoan: {
    icon: 'car',
    title: 'Enter auto loan details',
    buttonText: 'Add auto loan debt',
    label: 'Auto loan',
    value: 'autoLoan',
    interestRateStat:
      'The national average interest rate for car loans is 5.06%. If yours is different, edit the field below.',
    interestRateSource: (
      <span>
        The national average loan interest rate is based on average loan rates for credit scores of 601-780. Rate
        sourced from 2020{' '}
        <a href="https://www.experian.com/content/dam/marketing/na/automotive/quarterly-webinars/credit-trends/q3-2020-safm.pdf">
          Experian data
        </a>
        .
      </span>
    ),
    defaultInterestRate: 5.06,
    listTitle: 'Auto Loan Debt',
    xAxisLabel: 'Auto Loan',
    colors: {
      balance: '#00B5AF',
      interest: '#009490',
    },
  },
  studentLoans: {
    icon: 'loans',
    title: 'Enter student loan details',
    buttonText: 'Add student loan debt',
    label: 'Student loans',
    value: 'studentLoans',
    interestRateStat:
      'The national average interest rate for federal student loans is 2.27%. If yours is different, edit the field below. ',
    interestRateSource: (
      <span>
        The national average loan interest rate is based on undergraduate federal loans. Rate sourced from{' '}
        <a href="https://www.nerdwallet.com/">nerdwallet.com</a>, 2020.
      </span>
    ),
    defaultInterestRate: 2.27,
    listTitle: 'Student Loan Debt',
    xAxisLabel: 'Student Loans',
    colors: {
      balance: '#6991F2',
      interest: '#1045C1',
    },
  },
  heloc: {
    icon: 'heloc',
    title: 'Enter your HELOC details',
    buttonText: 'Add HELOC debt',
    label: 'HELOC',
    value: 'heloc',
    interestRateStat:
      'The national average interest rate for a HELOC is 7.04%. If yours is different, edit the field below.',
    interestRateSource: (
      <span>
        Loan interest rate is based on average loan rates for credit scores 700-719. Rate sourced from{' '}
        <a href="https://www.businessinsider.com/personal-finance/average-heloc-interest-rate">businessinsider.com</a>,
        2020.
      </span>
    ),
    defaultInterestRate: 7.04,
    listTitle: 'HELOC Debt',
    xAxisLabel: 'HELOC',
    colors: {
      balance: '#23BE8A',
      interest: '#18936A',
    },
  },
  other: {
    icon: 'wallet',
    title: 'Enter your details',
    buttonText: 'Add loan debt',
    label: 'Other',
    value: 'other',
    interestRateStat: null,
    defaultInterestRate: null,
    listTitle: 'Other Debt',
    xAxisLabel: 'Other',
    colors: {
      balance: '#70DAFF',
      interest: '#2AB4E4',
    },
  },
};
